import Dialog from "@mui/material/Dialog";

import connectConfig from "@/config/connectConfig";
import LoadingButton from "@mui/lab/LoadingButton";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { getDistance } from "geolib";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import moment from "moment";
import React from "react";
// Navigate
import { getAddress } from "@/fetch/fetchRoster";
import TextField from "@mui/material/TextField";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { Icon } from "leaflet";
import defaultIconPng from "leaflet/dist/images/marker-icon.png";
import _ from "lodash";
import {
  Circle,
  FeatureGroup,
  MapContainer,
  Marker,
  Polyline,
  TileLayer,
  Tooltip,
} from "react-leaflet";

export default function CheckInDialog(props) {
  const {
    onCancel,
    open,
    onSubmit,
    actions,
    submitMessage = "提交",
    cancelMessage = "取消",
    roster,
    handleOnChange,
    submitButtonColor = "primary",
  } = props;
  const defaultIcon = new Icon({
    iconUrl: defaultIconPng,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });
  const [isLoading, setLoading] = React.useState({
    checkin: false,
    checkout: false,
  });

  const [isShowMap, setIsShowMap] = React.useState(false);
  const [mapLatitude, setMapLatitude] = React.useState(null);
  const [mapLongitude, setMapLongitude] = React.useState(null);
  const [markerName, setMarkerName] = React.useState(null);
  const [img, setImg] = React.useState(null);
  const showDetail = async (type) => {
    setLoading({
      checkin: type === "checkin",
      checkout: type === "checkout",
    });
    const latitude = roster[`${type}_latitude`];
    const longitude = roster[`${type}_longitude`];

    const image = roster[`${type}_image`];
    if (latitude && longitude) {
      const { display_name } = await getAddress(latitude, longitude);
      setMarkerName(
        _.chain(_.split(display_name, ",").reverse().join(",")).value()
      );
      setMapLatitude(latitude);
      setMapLongitude(longitude);
      setIsShowMap(true);
    }

    if (roster.lat && roster.lng) {
      containerRef?.current?.setView([roster.lat, roster.lng], 17);
    }
    if (image) {
      setImg(`${connectConfig.s3}/${image}`);
    } else {
      setImg(null);
    }

    setLoading({ checkin: false, checkout: false });
  };
  const containerRef = React.useRef(null);
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
    >
      <DialogTitle>
        {roster.alias} - {roster.work_name}({roster.work_shortcode}){" "}
        {moment(roster.date).format("YYYY-MM-DD")}
      </DialogTitle>
      <DialogContent style={{ paddingTop: 10 }}>
        <DialogContentText>
          <Box noValidate>
            <Grid container spacing={2} justify="flex-end" alignItems="center">
              <Grid size={3}>
                <TimePicker
                  id="startTime"
                  name="startTime"
                  label="簽入時間"
                  type="time"
                  style={{ width: "100%" }}
                  value={roster.time_checkedin}
                  maxTime={moment(roster.time_checkedout)}
                  onChange={(value) => {
                    handleOnChange(value, "time_checkedin");
                  }}
                  renderInput={(params) => (
                    <TextField {...params} sx={{ width: "100%" }} />
                  )}
                ></TimePicker>
              </Grid>
              <Grid size={3}>
                {((roster.checkin_latitude && roster.checkin_longitude) ||
                  roster.checkin_image) && (
                  <LoadingButton
                    loading={isLoading.checkin}
                    variant="contained"
                    onClick={() => showDetail("checkin")}
                  >
                    顯示簽入資料
                  </LoadingButton>
                )}
              </Grid>

              <Grid size={3}>
                <TimePicker
                  id="endTime"
                  name="endTime"
                  label="簽出時間"
                  type="time"
                  style={{ width: "100%" }}
                  value={roster.time_checkedout}
                  minTime={moment(roster.time_checkedin)}
                  onChange={(value) => {
                    handleOnChange(value, "time_checkedout");
                  }}
                  renderInput={(params) => (
                    <TextField {...params} sx={{ width: "100%" }} />
                  )}
                ></TimePicker>
              </Grid>
              <Grid size={3}>
                {((roster.checkout_latitude && roster.checkout_longitude) ||
                  roster.checkout_image) && (
                  <LoadingButton
                    loading={isLoading.checkout}
                    variant="contained"
                    onClick={() => showDetail("checkout")}
                  >
                    顯示簽出資料
                  </LoadingButton>
                )}
              </Grid>
            </Grid>
            <Box noValidate style={{ marginTop: "20px" }}>
              {isShowMap && (
                <MapContainer
                  center={[
                    roster?.lat ?? mapLatitude,
                    roster?.lng ?? mapLongitude,
                  ]}
                  zoom={17}
                  scrollWheelZoom={false}
                  ref={containerRef}
                >
                  <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  />
                  <Marker
                    icon={defaultIcon}
                    position={[mapLatitude, mapLongitude]}
                  >
                    <Tooltip>
                      Latitude:{mapLatitude} <br /> Longitude:{mapLongitude}{" "}
                      <br /> {markerName}
                    </Tooltip>
                  </Marker>
                  {roster?.lng && roster?.lat && (
                    <React.Fragment>
                      <Marker
                        icon={defaultIcon}
                        position={[roster.lat, roster.lng]}
                      >
                        <Tooltip>
                          ({roster.work_shortcode}) {roster.work_name} <br />
                          {roster.work_address}
                        </Tooltip>
                      </Marker>
                      <FeatureGroup pathOptions={{ color: "red" }}>
                        <Circle
                          center={[roster.lat, roster.lng]}
                          radius={roster.radius}
                        />
                      </FeatureGroup>
                      <FeatureGroup>
                        <Polyline
                          positions={[
                            [roster.lat, roster.lng],
                            [mapLatitude, mapLongitude],
                          ]}
                        ></Polyline>
                        <Tooltip
                          direction="bottom"
                          offset={[0, 20]}
                          opacity={1}
                        >
                          距離
                          {getDistance(
                            { latitude: roster.lat, longitude: roster.lng },
                            { latitude: mapLatitude, longitude: mapLongitude }
                          )}
                          米
                        </Tooltip>
                      </FeatureGroup>
                    </React.Fragment>
                  )}
                </MapContainer>
              )}
              <Box
                component="img"
                sx={{
                  width: "100%",
                  marginTop: "20px",
                }}
                src={img}
              />
            </Box>
          </Box>
        </DialogContentText>
      </DialogContent>
      {actions?.update && (
        <DialogActions>
          <Button onClick={onCancel}>{cancelMessage}</Button>
          <Button onClick={onSubmit} color={submitButtonColor} type="submit">
            {submitMessage}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
}
